import PaintPlanningWorkspace from '../../placeholders/PaintPlanningWorkspace';

export default PaintPlanningWorkspace;
